import React from "react";
import {
  breakpointClasses,
  cn,
  resolveElement,
  splitBreakpointProps,
} from "@/lib/utils";
import { type ButtonElement, type ButtonProps, buttonVariants } from "./types";

function Button<E extends React.ElementType = ButtonElement>({
  as,
  asChild = false,
  className,
  variant,
  size,
  ref,
  ...props
}: ButtonProps<E>) {
  const Component = resolveElement(asChild, as, "div");
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  if (process.env.NODE_ENV !== "production" && as && asChild) {
    console.warn(
      `[Button] 'asChild' renders the child element; 'as' is ignored.`,
    );
  }

  return (
    <Component
      ref={ref}
      className={cn(
        buttonVariants({ className: cn(className, classes), size, variant }),
      )}
      {...native}
    />
  );
}

export default Button;
